import React from "react";
import { Link } from "react-router-dom";
import RankingGamesPage from "../modules/ContentManager/games/RankingGamesPage";

/**
 * Vista pública del ranking / pódium (sin login).
 * Ruta: /ranking-game/:id
 */
export default function PublicRankingGamesPage() {
	return (
		<div className="d-flex flex-column min-vh-100 bg-light">
			<header className="px-4 py-3 border-bottom bg-white d-flex justify-content-between align-items-center flex-wrap gap-2">
				<span className="text-muted small">Clasificación / pódium (solo lectura)</span>
				<Link to="/auth/login" className="btn btn-sm btn-light border">
					Acceso administración
				</Link>
			</header>
			<main className="flex-grow-1 p-3 p-md-4">
				<RankingGamesPage publicMode />
			</main>
		</div>
	);
}
